import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "transparent",
    boxShadow: "0px 4px 24px rgba(85, 100, 119, 0.08)",
    borderRadius: "2px",
    maxWidth: "1280px",
    width: "100%",
    '@media print': {
      boxShadow: 'none',
    }
  },
}));

export default function CalculatorContainer(props) {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ margin: props.margin }}>
      {props.children}
    </div>
  );
}
